import { api } from "@/api";
import type { FavouritesMenuGroup, MenuItem, PipelinesMenu } from "@/types/domain";

export const fetchMenuItems = async (url: string): Promise<MenuItem[]> => {
  const response = await api.get<{ result: MenuItem[] }>("/menu/create", {
    params: { url },
  });
  return response.data.result ?? [];
};

export const fetchFavouritesMenu = async (url: string): Promise<FavouritesMenuGroup[]> => {
  const response = await api.get<{ result: FavouritesMenuGroup[] }>("/menu/favouritesmenu", {
    params: { url },
  });
  return response.data.result ?? [];
};

export const fetchPipelinesMenu = async (url: string): Promise<PipelinesMenu> => {
  const response = await api.get<{ result: PipelinesMenu }>("/menu/pipelinesmenu", {
    params: { url },
  });
  return response.data.result;
};
